import {createReducer} from 'redux-act';
import * as actions from '../actions/auth';
import type {ChallengeRequired, TokenResponse} from "../../services/AuthService";
import storageService from "../../services/StorageService";
import authService from "../../services/AuthService";

const DEFAULT_STATE = {
  loginFailed: false,
  challenge: null,
  challengeFailed: false,
  token: storageService.load("token"),
  user: authService.loadUserFromStorage(),
  forgotPasswordUsername: null,
  forgotPasswordSubmitted: false
};

export default createReducer(
  {
    [actions.loginFailed]: state => ({
      ...state,
      loginFailed: true
    }),
    [actions.challengeRequired]: (state, payload: ChallengeRequired) => ({
      ...state,
      challengeFailed: false,
      loginFailed: false,
      challenge: payload
    }),
    [actions.clearLoginError]: state => ({
      ...state,
      loginFailed: false
    }),
    [actions.respondNewPasswordChallengeSuccessful]: (state, payload: TokenResponse) => {
      storageService.store("token", payload);
      return {
        ...state,
        loginFailed: false,
        challengeFailed: false,
        token: payload,
        user: authService.loadUserFromStorage()
      };
    },
    [actions.loginSuccessful]: (state, payload: TokenResponse) => {
      storageService.store("token", payload);
      return {
        ...state,
        loginFailed: false,
        token: payload,
        user: authService.loadUserFromStorage()
      };
    },
    [actions.logoutSuccessful]: (state) => {
      storageService.remove("token");
      return {
        ...state,
        token: null,
        user: null
      };
    },
    [actions.refreshTokenSuccessful]: (state, payload: TokenResponse) => {
      storageService.store("token", payload);
      return {
        ...state,
        token: payload,
        user: authService.loadUserFromStorage()
      };
    },
    [actions.forgotPasswordSubmit]: (state, username) => ({
      ...state,
      forgotPasswordUsername: username,
      forgotPasswordSubmitted: true
    }),
    [actions.clearForgotPassword]: (state) => ({
      ...state,
      forgotPasswordUsername: null,
      forgotPasswordSubmitted: false
    })
  },
  DEFAULT_STATE
);